import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getScheduleDraft = api(async function getScheduleDraft({ projectId, scheduleId }) {
    if (!projectId || !scheduleId) return null
    return query(
        gql`
            query GetScheduleDraft($projectId: String!, $scheduleId: String!) {
                getScheduleDraft(projectId: $projectId, scheduleId: $scheduleId) {
                    _id
                    id
                    projectId
                    sourceScheduleId
                    reviewCycle
                    status
                    seedSource
                    legacyScheduleTypes
                    legacyScheduleGroups
                    draft {
                        _id
                        id
                        version
                        code
                        title
                        unitOfMeasure
                        intro {
                            content
                            note
                        }
                        tasks {
                            id
                            isHeader
                            title
                            classification
                            content
                            note
                            taskId
                            headerTaskId
                            componentRef
                            linkedFields
                            frequency {
                                period
                                interval
                            }
                            skillSet
                            minutes
                            unitOfMeasure
                        }
                        legislation
                    }
                }
            }
        `,
        { projectId, scheduleId },
        {
            returns: "getScheduleDraft",
            fetchPolicy: "network-only",
        }
    )
})
